// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ContractsModal_modalContainer__1PIgb","modalFooter":"ContractsModal_modalFooter__3zB5E"};